<template>
  <ticketreceipt-check
    :sna-id="snaId"
  >
    <template #footer>
      <check-module :title="`审批`">
        <check-handle-module
          :pass-dialog-txt="`审批通过后收款流程将流转到下一阶段。`"
          :check-from-data="checkFromData"
          @submitCheck="submitCheck"
        ></check-handle-module>
      </check-module>
    </template>
  </ticketreceipt-check>
</template>

<script>
import checkMixin from '@/mixin/checkMixin'
import TicketreceiptCheck from '@/views/workbench/workCheckManage/ticketreceiptCheck/ticketreceiptCheck'

export default {
  name: 'ticketreceiptCheckView',
  components: { TicketreceiptCheck },
  mixins: [checkMixin],
  data () {
    return {
      checkDetailName: 'ticketreceiptcheckdetail'
    }
  },
  methods: {
    submitCheck () {}
  }
}
</script>

<style scoped>

</style>
